import React from 'react'

export default () => (
  <svg
    width="auto"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_5464_9762)">
      <path
        d="M0 3.83374L4.86237 11.2616H11.1617L9.73094 9.07495H14.2716L8.85162 17.3571L12 22.1662L24 3.83374L0 3.83374Z"
        fill="#FE2C2E"
      />
    </g>
    <defs>
      <clipPath id="clip0_5464_9762">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
